import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { UPDATE_BOARD_CLIENTS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { ADD_TO_BOARD } from "../store/applications-list-actions";
import { GET_CLIENT_INFORMATION_FOR_TRANSFER } from "../store/applications-list-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddToBoard",
  props: {
    client: {
      type: Object,
      required: true
    },
    responsive: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS])), mapGetters("ApplicationsListStore", [GET_CLIENT_INFORMATION_FOR_TRANSFER])), {}, {
    clientInformation() {
      return this.GET_CLIENT_INFORMATION_FOR_TRANSFER({
        clientUsername: this.client.username
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_BOARD_CLIENTS])), mapActions("ApplicationsListStore", [ADD_TO_BOARD])), {}, {
    async transferProfile(boardId, event) {
      var _context;
      event.preventDefault();
      const target = event.target;
      const button = _findInstanceProperty(_context = $(target).closest(".dropdown")).call(_context, ".btn");
      try {
        $(button).toggleClass("dropdown-toggle");
        $(button).animateButton().animate("start");
        await this.ADD_TO_BOARD({
          clientDetails: this.clientInformation,
          boardId
        });
        $(button).animateButton().animate("finish", "success");
      } catch (e) {
        $(button).animateButton().animate("finish", "failed");
        $(button).toggleClass("dropdown-toggle");
      }
    },
    getProfileLink(clientProfileId, boardId) {
      return {
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      };
    },
    numberOfClients(number) {
      const numberParsed = _parseInt(number);
      return `${numberParsed} ${this.$tc("global.doorr.client", numberParsed)}`;
    }
  })
});